import theme from 'live/services/theme'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 5px 0 20px;
`

export const Delimiter = styled.div`
    border-right: 1px solid ${theme['link-color']};
    height: 20px;
    margin: 0 10px;
`

export const Space = styled.div`
    display: flex;
    flex-direction: row;
    color: ${theme['input-text-color']};
    cursor: pointer;

    b {
        font-weight: 600;
        color: ${theme['auxiliar-typography']};
    }

    span {
        margin-left: 5px;
    }

    i {
        font-size: 16px;
        line-height: 16px;
        margin-left: 5px;
        cursor: pointer;
        color: ${theme['link-color']};

        &.fa-star {
            cursor: unset;
            font-weight: 600;
            color: ${theme['favorite-yellow']};
            margin-right: 10px;
        }
    }
`
